// extracted by mini-css-extract-plugin
export default {"wrapper":"ExpenseGroupPage_wrapper__RwFxM"};